import { render, staticRenderFns } from "./CompanyDocuments.vue?vue&type=template&id=5bca0d90&scoped=true&"
import script from "./CompanyDocuments.vue?vue&type=script&lang=js&"
export * from "./CompanyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDocuments.vue?vue&type=style&index=0&id=5bca0d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca0d90",
  null
  
)

export default component.exports